import React, { useState, useEffect } from 'react'
import { Courses } from './Sections/courses'
import { Classes } from './Sections/classes'
import { Profile } from './Sections/profile'
import { Earnings } from './Sections/earnings'
import { Box, Typography } from '@mui/material'
import { useLocation } from 'react-router-dom';
import { educatorDashboardSX, LeftBox, MainBox, RightBox } from './styles'
import { useDispatch, useSelector } from 'react-redux'
import AuthModals from '../Common/AuthModals/authModals'
import { chooseStripeOnboardingCompleteModal, closeChooseModal, ModalTypes } from '../../Infrastructure/States/authModalsSlice';
import SectionNotFound from '../Common/Error404/sectionNotFound'

export const EducatorDashboard = () => {
    const location = useLocation()
    const dispatch = useDispatch()
    const [error, setError] = useState(null);
    const [tab, setTab] = useState("courses");
    const [loading, setLoading] = useState(false)
    const [createStripeAccLoading, setCreateStripeAccLoading] = useState(false)
    const userData = useSelector((state) => state.userData.data);
    const stripeAccountStatus = userData?.educator?.stripe_status
    const educatorApproved = userData?.educator?.approved
    const accountId = userData?.educator?.stripe_id;
    const currentModal = useSelector((state) => state.auth.chooseModal);
    const handleClose = () => {
        dispatch(closeChooseModal());
        if (stripeAccountStatus === "not_started" || stripeAccountStatus === "partial") {
            dispatch(chooseStripeOnboardingCompleteModal())
        }
    }
    const handleTabChange = (newTab) => {
        if (tab !== newTab) {
            setTab(newTab);
            window.location.hash = newTab;
        }
    }
    useEffect(() => {
        const hash = location.hash.substring(1);
        if (hash) {
            setTab(hash);
        } else {
            // If no hash, set default to courses and update URL
            setTab('courses');
            window.location.hash = 'courses';
        }
    }, [location.hash]);
    useEffect(() => {
        if (
            educatorApproved &&
            !createStripeAccLoading &&
            currentModal !== ModalTypes.COURSE_COMPLETION &&
            (stripeAccountStatus === "not_started" || stripeAccountStatus === "partial")
        ) {
            dispatch(chooseStripeOnboardingCompleteModal());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stripeAccountStatus, educatorApproved]);

    return (
        educatorApproved ?
            <>
                <AuthModals chooseModal={currentModal} handleClose={handleClose} />
                <MainBox sx={educatorDashboardSX.mainBox}>
                    <Box sx={educatorDashboardSX.leftWrapper}>
                        <LeftBox>
                            <Typography variant="h6" color={tab === 'courses' && "primary"} sx={educatorDashboardSX.tabText} onClick={() => handleTabChange('courses')}>Courses</Typography>
                            <Typography variant="h6" color={tab === 'classes' && "primary"} sx={educatorDashboardSX.tabText} onClick={() => handleTabChange('classes')}>Classes</Typography>
                            <Typography variant="h6" color={tab === 'profile' && "primary"} sx={educatorDashboardSX.tabText} onClick={() => handleTabChange('profile')}>Profile</Typography>
                            <Typography variant="h6" color={tab === 'earnings' && "primary"} sx={educatorDashboardSX.tabText} onClick={() => handleTabChange('earnings')}>Earnings</Typography>
                        </LeftBox>
                    </Box>
                    <RightBox sx={educatorDashboardSX.rightBox}>
                        {tab === 'courses' ? (
                            <Courses handleTabChange={handleTabChange}/>
                        ) : tab === 'classes' ? (
                            <Classes />
                        ) : tab === 'profile' ? (
                            <Profile />
                        ) : tab === 'earnings' ? (
                            <Earnings accountId={accountId} stripeAccountStatus={stripeAccountStatus} loading={loading} setCreateStripeAccLoading={setCreateStripeAccLoading} setLoading={setLoading} error={error} setError={setError} />
                        ) : <SectionNotFound tab={tab}/>
                        }
                    </RightBox>
                </MainBox>
            </>
            :
            <Box sx={educatorDashboardSX.pendingContainer}>
                <Typography sx={educatorDashboardSX.pendingTitle} color="primary">Application Submitted!</Typography>
                <Typography sx={educatorDashboardSX.pendingText} color="initial">Your educator application has been submitted and you will be notified via email once review is complete. In the meantime, keep an eye out for any follow-up emails or calls requesting further information.</Typography>
            </Box>
    )
}
